// src/utils/consent.js

// Google Tag Manager (en daarmee GA, DoubleClick en LinkedIn Insight) laadt pas
// na toestemming: zonder keuze of na weigeren gaat er niets naar derden.
const CONSENT_KEY = 'cookieConsent';
const GTM_ID = 'GTM-KWCKC5K';
const GTM_SRC = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
const OPEN_SETTINGS_EVENT = 'cookie-settings-open';
const CHOSEN_EVENT = 'cookie-consent-chosen';

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

export function setConsent(value) {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // storage geblokkeerd: de keuze geldt dan alleen voor deze pagina
  }
  window.dispatchEvent(new Event(CHOSEN_EVENT));
}

/** Na een keuze in de cookiebanner; de aankondiging wacht daarop. */
export function onConsentChosen(handler) {
  window.addEventListener(CHOSEN_EVENT, handler);
  return () => window.removeEventListener(CHOSEN_EVENT, handler);
}

/** Opent de cookiebanner opnieuw, zodat een bezoeker een eerdere keuze kan wijzigen. */
export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
}

export function onOpenCookieSettings(handler) {
  window.addEventListener(OPEN_SETTINGS_EVENT, handler);
  return () => window.removeEventListener(OPEN_SETTINGS_EVENT, handler);
}

export function isTrackingLoaded() {
  return Boolean(document.querySelector(`script[src="${GTM_SRC}"]`));
}

/**
 * Laadt GTM één keer en meldt daarna de toestemming aan de container, zodat
 * de triggers op `cookie_consent_granted` blijven werken.
 */
export function loadTracking() {
  if (isTrackingLoaded()) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const script = document.createElement('script');
  script.async = true;
  script.src = GTM_SRC;
  document.head.appendChild(script);

  window.dataLayer.push({ event: 'cookie_consent_granted' });
}
